import { Sizes } from '../constants/size';
import type { IconProps } from '../types/icon-props';

export const Charger = (props: IconProps) => {
  const { size = 'md', fill = '#9696a0', ...rest } = props;

  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={Sizes[size]}
      height={Sizes[size]}
      viewBox="0 0 16 17"
      {...rest}
      fill={fill}
    >
      <g fillRule="evenodd" clipPath="url(#a)" clipRule="evenodd">
        <path d="M11.945 2.867c0-.185.15-.334.333-.334h2.315c.184 0 .333.15.333.334v1.677a1.49 1.49 0 1 1-2.981 0V2.867Zm.667.333v1.344a.824.824 0 1 0 1.647 0V3.2h-1.647ZM1.072 5.458c0-.184.15-.333.334-.333h6.99c.184 0 .334.15.334.333v5.15c0 .184-.15.334-.334.334h-6.99a.333.333 0 0 1-.334-.334v-5.15Zm.667.333v4.484h6.324V5.791H1.739Z" />
        <path d="M3.638.807c.184 0 .333.149.333.333v1.53h1.86V1.14a.333.333 0 0 1 .667 0v1.53h.124c.53 0 .958.43.958.959v1.83c0 .183-.149.332-.333.332H2.556a.333.333 0 0 1-.333-.333v-1.83c0-.529.429-.958.958-.958h.124V1.14c0-.184.15-.333.333-.333Zm9.798.89c.184 0 .334.15.334.334v.605a.333.333 0 1 1-.667 0V2.03c0-.184.15-.333.333-.333ZM3.181 3.338a.292.292 0 0 0-.292.292v1.496h4.025V3.629a.292.292 0 0 0-.292-.292H3.181Zm10.255 2.344c.184 0 .334.149.334.333v5.92a4.6 4.6 0 0 1-9.202 0v-1.329a.333.333 0 0 1 .667 0v1.33a3.934 3.934 0 0 0 7.868 0V6.014c0-.184.15-.333.333-.333Z" />
      </g>
      <defs>
        <clipPath id="a">
          <path d="M0 .672h16V16.67H0z" />
        </clipPath>
      </defs>
    </svg>
  );
};

Charger.category = 'product-category';

Charger.displayName = 'Charger';
